import { useState } from 'react';
import { useAccountOpeningReasonAnalytics } from './useAccountOpeningReasonAnalytics';
import { REASON_FOR_OPEN } from '../consts';
import { useSendAccountOpeningReason } from './useSendAccountOpeningReason';

export const useAccountOpeningReasonLogic = () => {
  const { reportActOnAccountOpenReason } = useAccountOpeningReasonAnalytics();
  const { mutateAsync, isPending } = useSendAccountOpeningReason();

  const [isOtherModalOpen, setIsOtherModalOpen] = useState(false);

  const onClickItem = async (reason: REASON_FOR_OPEN, title: string) => {
    reportActOnAccountOpenReason(reason);
    if (reason === REASON_FOR_OPEN.OTHER) {
      openModal();
      return;
    }
    mutateAsync(title);
  };

  const openModal = () => {
    setIsOtherModalOpen(true);
  };

  const closeModal = () => {
    setIsOtherModalOpen(false);
  };

  return {
    reportActOnAccountOpenReason,
    isOtherModalOpen,
    setIsOtherModalOpen,
    onClickItem,
    openModal,
    closeModal,
    mutateAsync,
    isPending,
  };
};
